import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signupPayroll } from '../api';
import BrandMark from '../components/BrandMark';

export default function SignupPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setMessage('');
    setBusy(true);
    try {
      const { data } = await signupPayroll({ email, password, confirmPassword, displayName });
      if (data?.status !== 'Ok') {
        throw new Error(data?.message || 'Signup failed.');
      }
      setMessage('Account created. Sign in to open your Payroll workspace.');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      setError(err.message || 'Signup failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="shell">
      <BrandMark />
      <h1 className="hero-title" style={{ fontSize: '2.2rem' }}>Create a Payroll account</h1>
      <p className="lede">No Bistro account required. You will get a standalone payroll workspace after sign-in.</p>
      <form className="form" onSubmit={handleSubmit}>
        <label>
          Workspace name
          <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="Acme Cafe Payroll" />
        </label>
        <label>
          Email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
        </label>
        <label>
          Password
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="new-password" minLength={6} />
        </label>
        <label>
          Confirm password
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required autoComplete="new-password" minLength={6} />
        </label>
        {error ? <p className="error">{error}</p> : null}
        {message ? <p className="muted">{message}</p> : null}
        <button className="btn btn-primary" type="submit" disabled={busy}>
          {busy ? 'Creating…' : 'Create account'}
        </button>
      </form>
      <div className="cta-row">
        <Link className="btn btn-secondary" to="/login">Already have an account?</Link>
      </div>
    </div>
  );
}